import type { Ref } from '@/composition/vue/compositionApi'

export const TilesSwitchSymbol = Symbol('tilesSwitch')
export type TilesSwitchPayload = {
  modelValue: Ref<string>
  setModelValue: (value: string) => void
}
